import React, {FC} from 'react'
import { translateBase, icon } from '../../helpers'

import Risks from './Risks'
import AMLOfficers from './AMLOfficers'
import { RiskProps } from '../../types'

const Container:FC<RiskProps> = (props) => {
  return (
    <>
      {/*@ts-ignore*/}
      <Risks {...props} />
      <AMLOfficers {...props} />
    </>
  )
}

//@ts-ignore
Container.config = {
  title: () => translateBase('tb_risklevels'),
  name: 'risks',
  component: Container,
  api: ['risks', 'linkedfiles', 'amlrecords'],
  icon: icon('tb_risklevels'),
}

export default Container
